import { DevTool } from '@hookform/devtools';
import { yupResolver } from '@hookform/resolvers/yup';
import { TextField, Button } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { IGroundWaterZoneFormValues } from '../../../../@types/model/borehole/groundWaterZone/groundWaterZoneFormValues';
import GroundWaterZoneModelHelper from '../../../../@types/model/borehole/groundWaterZone/groundWaterZoneModelHelper';
import PillButton from '../../../customComponentV2/button/PillButton';
import ControlledLabelledCheckBox from '../../../customComponentV2/input/ControlledLabelledCheckBox';

interface IGroundWaterZoneEditFormProps {
    initialValues : IGroundWaterZoneFormValues;
    onSubmit : (values : IGroundWaterZoneFormValues) => void;
    onClose : () => void;
}

const GroundWaterZoneEditForm = (props : IGroundWaterZoneEditFormProps) : React.ReactElement => {
    const schema = GroundWaterZoneModelHelper.formSchema();

    const { register, handleSubmit, control, formState: { errors, isValid, isDirty } } = useForm<IGroundWaterZoneFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(schema),
        mode: 'onChange'
    });

    return (
        <>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p30 pt15 pb0'}>
                    <div className={'fdc wfill pt10 jcc aic'}>
                        <div className={'wfill mb15'}>
                            <TextField 
                                {...register('code')}
                                label={'Code'}
                                className={'wfill'}
                                error={!!errors.code} 
                                helperText={errors.code ? errors.code.message : ''}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#B4B4B4',
                                        borderWidth: '1px',
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className={'fdc wfill pt10 jcc aic'}>
                        <div className={'wfill mb15'}>
                            <TextField 
                                {...register('name')}
                                label={'Name'}
                                className={'wfill'}
                                error={!!errors.name}
                                helperText={errors.name ? errors.name.message : ''}
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#B4B4B4',
                                        borderWidth: '1px',
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className='h20'/>
                    <div className='flx1 fdr jcfs'>
                        <ControlledLabelledCheckBox 
                            name={'isActive'}
                            label={'Is Active?'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe mb20'}>
                        <Button 
                            className={'cpd mr20'}
                            onClick={props.onClose} 
                            type={'reset'}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30 bcy'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={!isValid || !isDirty}
                        />
                    </div>
                </div>
            </form>
            <DevTool control={control} />
        </>
    );
};

export default GroundWaterZoneEditForm;
